var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagAustralia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_14908)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 24.8365 24.8365 32 16 32C7.1635 32 0 24.8365 0 16C0 16.0037 16 0.0018125 16 0C24.8365 0 32 7.1635 32 16Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9572 16.0001H16C16 15.9856 16 15.9717 16 15.9573C15.9857 15.9716 15.9715 15.9858 15.9572 16.0001Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 8.34781C16 5.5325 16 3.68769 16 0H15.9973C7.162 0.0014375 0 7.16425 0 15.9999H8.34781V11.2992L13.0486 15.9999H15.9572C15.9716 15.9857 15.9858 15.9714 16.0001 15.9571C16.0001 14.8792 16.0001 13.9174 16.0001 13.0486L11.2992 8.34781H16Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.09469 2.08691C5.59226 3.51185 3.51188 5.59223 2.08694 8.09466V16H6.26088V6.26091V6.26085H16C16 4.94441 16 3.69029 16 2.08691H8.09469Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 14.0324L10.3154 8.34793H8.34789C8.34789 8.34787 8.34789 8.34793 8.34789 8.34793L15.9999 16H16C16 16 16 14.6434 16 14.0324Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.64969 18.7827L10.5278 20.6188L12.5108 20.1605L11.6228 21.9919L13.2174 23.2565L11.2319 23.704L11.2375 25.7392L9.64969 24.4659L8.06194 25.7392L8.0675 23.704L6.082 23.2565L7.67669 21.9919L6.78856 20.1605L8.77163 20.6188L9.64969 18.7827Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9557 22.261L24.3947 23.179L25.3862 22.9499L24.9422 23.8655L25.7395 24.4979L24.7468 24.7216L24.7495 25.7392L23.9557 25.1025L23.1618 25.7392L23.1645 24.7216L22.1718 24.4979L22.9692 23.8655L22.5252 22.9499L23.5166 23.179L23.9557 22.261Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8708 12.5217L20.3098 13.4399L21.3013 13.2106L20.8573 14.1263L21.6546 14.7586L20.6619 14.9824L20.6646 16L19.8708 15.3633L19.0769 16L19.0796 14.9824L18.0869 14.7586L18.8843 14.1263L18.4403 13.2106L19.4318 13.4399L19.8708 12.5217Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9557 6.95654L24.3947 7.87467L25.3862 7.64548L24.9422 8.56117L25.7395 9.19342L24.7468 9.41723L24.7495 10.4349L23.9557 9.79817L23.1618 10.4349L23.1645 9.41723L22.1718 9.19342L22.9691 8.56117L22.5252 7.64548L23.5166 7.87467L23.9557 6.95654Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.523 11.1304L27.962 12.0485L28.9535 11.8192L28.5095 12.7349L29.3068 13.3672L28.3141 13.5911L28.3168 14.6086L27.523 13.972L26.7291 14.6086L26.7318 13.5911L25.7391 13.3672L26.5364 12.7349L26.0924 11.8192L27.0839 12.0485L27.523 11.1304Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9719 16L25.3172 17.0629H26.4348L25.5306 17.7198L25.8761 18.7826L24.9719 18.1257L24.0678 18.7826L24.4131 17.7198L23.5089 17.0629H24.6265L24.9719 16Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_14908"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagAustralia);
export default __webpack_public_path__ + "static/media/flag_australia.8f31bb5d0a1ecf7b9c76ca8e865a8e53.svg";
export { ForwardRef as ReactComponent };